const a = {
  disabled: !1
};
export {
  a as default
};
//# sourceMappingURL=config.es.js.map
